import React, { useState, useEffect, useRef } from "react";
import { Input, Checkbox, Button, Spin } from "antd";
import { SearchOutlined, DownOutlined } from "@ant-design/icons";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../CustomWidgets/Laoding";
import { detectWebDeviceType } from "../../utils";
import { store } from "../../Redux/store";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";


const searchProductStockAvailability = async (
    val,
    searchBy,
    userId,
    companyId,
    limit,
    offset,
    lang
) => {
    try {
        const shared = {
            user_id: userId,
            company_id: companyId,
            limit,
            offset,
            lang,
        };

        let payload = {};

        if (searchBy === "BARCODE") {
            payload = {
                ...shared,
                barcode: val,
            };
        } else if (searchBy === "NAME") {
            payload = {
                ...shared,
                product_name: val,
            };
        } else {
            payload = {
                ...shared,
                short_code: val,
            };
        }

        const res = await axiosInstance.post(
            process.env.REACT_APP_API_URL_OLD + URLS.GET_AVAILABLE_STOCK_INFO,
            payload
        );

        console.log(res?.result?.response)
        return res;
    } catch (error) {
        console.error("Stock availability error:", error);
        throw error;
    }
};

function CheckStockAvailabilityModal({ open, onClose }) {
    const { t, i18n } = useTranslation();

    const [searchValue, setSearchValue] = useState("");
    const [shortCodeSearch, setShortCodeSearch] = useState("")
    const [searchBy, setSearchBy] = useState("NAME");
    const [stockData, setStockData] = useState([]);
    const userData = useSelector((state) => state?.login?.user?.result);
    const deviceType = detectWebDeviceType();
    const [showLeft, setShowLeft] = useState(false);
    const [storeStock, setStoreStock] = useState([])
    const [showStoreStockTable, setShowStoreStockTable] = useState(false)
    const isRTL = i18n.language === "ar";



    const [loading, setLoading] = useState(false);
    console.log("OPEN", open)

    const userId = userData?.user_id;
    const companyId = userData?.company_id;
    const lang = "en_US";

    const limit = 10;
    const offset = 0;

    const searchIdRef = useRef(0);

    const handleSearch = async () => {
        const valueToSearch =
            searchBy === "SHORT_CODE"
                ? shortCodeSearch
                : searchValue;

        // Invalidate any in-flight request every time handleSearch runs
        const requestId = ++searchIdRef.current;

        if (!valueToSearch.trim()) {
            setStockData([]);
            setShowStoreStockTable(false);
            setStoreStock([]);
            return;
        }

        try {
            setLoading(true);

            const response = await searchProductStockAvailability(
                valueToSearch.trim(),
                searchBy,
                userId,
                companyId,
                limit,
                offset,
                lang
            );

            // If a newer search has started since this one was fired, ignore this stale response
            if (requestId !== searchIdRef.current) return;

            setStockData(response?.data?.result?.[0]?.response || []);
        } catch (error) {
            if (requestId !== searchIdRef.current) return;
            setStockData([]);
        } finally {
            if (requestId === searchIdRef.current) {
                setLoading(false);
            }
        }
    };


    const handleClose = () => {
        setSearchValue("")
        setSearchBy("NAME")
        setStockData([])
        onClose?.();
    };



    // Optional: search automatically when the search type changes
    useEffect(() => {
        const valueToSearch =
            searchBy === "SHORT_CODE"
                ? shortCodeSearch
                : searchValue;

        const timer = setTimeout(() => {
            if (valueToSearch.length === 0 || valueToSearch.length > 2) {
                handleSearch();
            }
        }, 300);

        return () => clearTimeout(timer);
    }, [searchValue, shortCodeSearch, searchBy]);

    if (!open) {
        return null;
    }

    return (
        <div
            className={`fixed inset-0 z-[9999] flex justify-center ${deviceType == "tablet" ? "pt-32" : "items-center"
                }`}
            style={{ backdropFilter: "blur(10px)", backgroundColor: "rgba(0,0,0,0.4)" }}
        >

            <div
                className={`relative bg-white rounded-[20px] p-10 h-fit shadow-2xl animate-fadeIn overflow-y-auto ${deviceType == "tablet" ? "w-[1200px]" : "w-[1600px]"
                    }`}
                style={{ maxHeight: "90vh" }}
            >
                <button
                    onClick={handleClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-black text-2xl font-semibold"
                >
                    ×
                </button>
                <div className=" border-b-2 mb-2">
                    <h2 className="text-2xl font-semibold mb-4 text-gray-600">{t("Stock Availability Info")}</h2>
                </div>
                <div className="flex gap-x-6 items-start">

                    <div className="w-1/3 flex-shrink-0">

                        <div className="mb-8">
                            <div className="flex gap-3 mb-3 rounded-md">
                                <Input
                                    size="large"
                                    prefix={<SearchOutlined className="text-base" />}
                                    placeholder={t("Search Product")}
                                    value={searchBy === "SHORT_CODE" ? shortCodeSearch : searchValue}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(
                                            /[^\u0600-\u06FFa-zA-Z0-9\s]/g,
                                            ""
                                        );

                                        if (searchBy === "SHORT_CODE") {
                                            setShortCodeSearch(val.trimStart());
                                        } else {
                                            setSearchValue(val.trimStart());
                                            setSearchBy("NAME");
                                        }
                                    }}
                                    maxLength={25}
                                    className="mb-3 text-lg h-10 rounded-md overflow-hidden"
                                    styles={{
                                        addonAfter: {
                                            padding: 0,
                                            border: "none",
                                            background: "transparent",
                                        },
                                    }}
                                    addonAfter={
                                        <button
                                            type="button"
                                            onClick={() => {
                                                if (searchBy === "SHORT_CODE") {
                                                    setSearchBy("NAME");
                                                    setShortCodeSearch("");
                                                } else {
                                                    setSearchBy("SHORT_CODE");
                                                    setSearchValue("");
                                                }
                                            }}
                                            className={`h-10 w-[100px] border text-md whitespace-nowrap rounded-r-md
  ${searchBy === "SHORT_CODE"
                                                    ? "bg-blue-100 border-[#1b4597] text-[#1b4597]"
                                                    : "bg-white border-gray-300 text-gray-700"
                                                }`}
                                        >
                                            Short Code
                                        </button>
                                    }
                                />

                            </div>
                        </div>

                        <div className="w-full">
                            {loading ? (
                                <div className="flex justify-center py-4">
                                    <div className="w-8 h-8 border-2 border-gray-200 border-t-[#8DC63F] rounded-full animate-spin" />
                                </div>
                            ) : stockData.length > 0 ? (
                                <div className="w-full h-[400px] border rounded-lg bg-white p-3 overflow-y-auto">
                                    {stockData.map((stock) => (
                                        <div
                                            key={stock.id}
                                            className={`flex items-center py-2 px-2 rounded-md cursor-pointer hover:bg-green-50 ${storeStock === stock.store_wise_quantity &&
                                                    showStoreStockTable
                                                    ? "border border-[#8DC63F] bg-[#f6fbf0]"
                                                    : ""
                                                }`}
                                            onClick={() => {
                                                setShowStoreStockTable(true);
                                                setStoreStock(stock.store_wise_quantity);
                                            }}
                                        >
                                            <div className="w-16 h-16 flex-shrink-0 flex items-center justify-center rounded bg-white border border-gray-100 overflow-hidden">
                                                <img
                                                    src={stock.image_url}
                                                    alt={stock.name}
                                                    className="w-full h-full object-contain"
                                                />
                                            </div>

                                            <div className="flex-1 ml-3">
                                                <h3 className="font-medium text-gray-800">
                                                    {stock.name}
                                                </h3>

                                                <p className="text-sm text-gray-500">
                                                    Barcode: {stock.barcode}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : searchValue || shortCodeSearch ? (
                                <div className="flex flex-col items-center justify-center py-6 text-gray-500">
                                    <p className="text-md">No products found</p>
                                </div>
                            ) : (
                                <div className="flex flex-col items-center justify-center py-6 text-gray-400">
                                    <SearchOutlined className="text-2xl mb-2" />
                                    <p className="text-md">Search for a product</p>
                                    <p className="text-md mt-1">
                                        Search by product name, barcode or short code
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="w-2/3 flex-shrink-0">
                        <div className="w-full h-[500px] flex flex-col border rounded-lg bg-[#f9fafb] p-5 overflow-hidden">
                            <div className="flex items-center justify-between mb-4 flex-shrink-0">
                                <h3 className="text-xl font-semibold ">
                                    {t("Store Stock")}
                                </h3>
                            </div>
                            {showStoreStockTable ? (
                                <>
                                    <div className="flex-1 overflow-y-auto border rounded-lg bg-white">
                                        <table className="w-full border-collapse">
                                            <thead className="sticky top-0 bg-gray-100 z-10">
                                                <tr>
                                                    <th className="text-left px-4 py-3 font-semibold text-gray-800 border-b">
                                                        {t("Store Name")}
                                                    </th>
                                                    <th className="text-right px-4 py-3 font-semibold text-gray-800 border-b">
                                                        {t("Quantity")}
                                                    </th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {storeStock?.length > 0 ? (
                                                    storeStock.map((store, index) => (
                                                        <tr
                                                            key={`${store.store_name}-${index}`}
                                                            className="hover:bg-gray-50"
                                                        >
                                                            <td className="px-4 py-3 border-b text-gray-900">
                                                                {store.store_name}
                                                            </td>
                                                            <td
                                                                className={`px-4 py-3 border-b text-right font-medium ${Number(store.qty) < 0
                                                                    ? "text-red-900"
                                                                    : "text-gray-900"
                                                                    }`}
                                                            >
                                                                {store.qty}
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={2} className="px-4 py-6 text-center text-gray-500">
                                                            {t("No store stock available")}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            ) : (
                                <div className="h-full flex items-center justify-center text-gray-600 py-2 text-center">
                                    {t("Select a product to view store-wise stock")}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
               
            </div>
        </div>
    );
}

export default CheckStockAvailabilityModal;